import { jsx as _jsx } from "react/jsx-runtime";
// Этот простой компонент создан для унификации стилей/отступов
import { Row, Col } from 'react-bootstrap';
const Subsection = (props) => {
    const { fontType, label } = props;
    return (_jsx(Row, { className: `subsection ${(fontType === 16) ? 'avtoapp_color_font_16 pt-2' : 'avtoapp_color_font_20 pt-2'}`, children: _jsx(Col, { children: label }) }));
};
export default Subsection;
